/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M15.284 11.984c.616 0 1.08.142 1.393.427.318.286.477.709.477 1.27 0 .373-.071.686-.214.938a1.326 1.326 0 0 1-.628.566c-.276.129-.619.193-1.028.193h-.725V17h-1.07v-5.016zm-.725 2.518h.504c.368 0 .628-.062.78-.186.156-.13.235-.34.235-.635 0-.299-.08-.51-.236-.635-.151-.124-.411-.186-.779-.186h-.504zm4.971-.435 1.084-2.083h1.193l-1.76 3.056V17h-1.076v-1.96l-1.76-3.056h1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePy as FilePy };
